import { Product, ProductOption } from '../types/types'

export const CATEGORIES = [
  'Sándwich',
  'Wrap',
  'Cremas',
  'Snack Bowl',
  'Niños',
  'Bebidas',
]

// Ingredient images for visual builder
export const INGREDIENT_IMAGES: Record<string, string> = {
  // Bases
  b1: 'https://images.unsplash.com/photo-1612929633738-8fe44f7ec841?w=200&h=200&fit=crop', // rice noodles
  b2: 'https://images.unsplash.com/photo-1536304929831-ee1ca9d44906?w=200&h=200&fit=crop', // white rice
  b3: 'https://images.unsplash.com/photo-1622206151226-18ca2c9ab4a1?w=200&h=200&fit=crop', // lettuce
  b4: 'https://images.unsplash.com/photo-1586201375761-83865001e31c?w=200&h=200&fit=crop', // quinoa
  b5: 'https://images.unsplash.com/photo-1551462147-ff29053bfc14?w=200&h=200&fit=crop', // pasta
  b6: 'https://images.unsplash.com/photo-1540420773420-3366772f4999?w=200&h=200&fit=crop', // mixed greens
  // Proteinas
  p1: 'https://images.unsplash.com/photo-1467003909585-2f8a72700288?w=200&h=200&fit=crop', // salmon
  p2: 'https://images.unsplash.com/photo-1544551763-46a013bb70d5?w=200&h=200&fit=crop', // tuna
  p3: 'https://images.unsplash.com/photo-1565680018434-b513d5e5fd47?w=200&h=200&fit=crop', // shrimp
  p4: 'https://images.unsplash.com/photo-1604503468506-a8da13d82571?w=200&h=200&fit=crop', // chicken
  // Toppings
  t1: 'https://images.unsplash.com/photo-1504545102780-26774c1bb073?w=200&h=200&fit=crop', // mushrooms
  t2: 'https://images.unsplash.com/photo-1482049016688-2d3e1b311543?w=200&h=200&fit=crop', // boiled egg
  t3: 'https://images.unsplash.com/photo-1580201092675-a0a6a6cafbb1?w=200&h=200&fit=crop', // crispy onion
  t4: 'https://images.unsplash.com/photo-1551754655-cd27e38d2076?w=200&h=200&fit=crop', // corn
  t5: 'https://images.unsplash.com/photo-1587049352846-4a222e784d38?w=200&h=200&fit=crop', // red onion
  t6: 'https://images.unsplash.com/photo-1546470427-0d4db154ceb8?w=200&h=200&fit=crop', // cherry tomato
  t7: 'https://images.unsplash.com/photo-1551462147-37885acc36f1?w=200&h=200&fit=crop', // black beans
  t8: 'https://images.unsplash.com/photo-1563565375-f3fdfdbefa83?w=200&h=200&fit=crop', // bell pepper
  t9: 'https://images.unsplash.com/photo-1515543904413-63f5ce37e990?w=200&h=200&fit=crop', // chickpeas
  t10: 'https://images.unsplash.com/photo-1598170845058-32b9d6a5da37?w=200&h=200&fit=crop', // carrot
  t11: 'https://images.unsplash.com/photo-1571771894821-ce9b6c11b08e?w=200&h=200&fit=crop', // plantain
  t12: 'https://images.unsplash.com/photo-1583119022894-919a68a3d0e3?w=200&h=200&fit=crop', // scallion
  t13: 'https://images.unsplash.com/photo-1449300079323-02e209d9d3a6?w=200&h=200&fit=crop', // cucumber
  t14: 'https://images.unsplash.com/photo-1615485290382-441e4d049cb5?w=200&h=200&fit=crop', // hearts of palm
  t15: 'https://images.unsplash.com/photo-1553279768-865429fa0078?w=200&h=200&fit=crop', // mango
  t16: 'https://images.unsplash.com/photo-1464965911861-746a04b4bca6?w=200&h=200&fit=crop', // strawberry
  t17: 'https://images.unsplash.com/photo-1550258987-190a2d41a8ba?w=200&h=200&fit=crop', // pineapple
  t18: 'https://images.unsplash.com/photo-1509440159596-0249088772ff?w=200&h=200&fit=crop', // croutons
  // Premium
  tp1: 'https://images.unsplash.com/photo-1523049673857-eb18f1d7b578?w=200&h=200&fit=crop', // avocado
  tp2: 'https://images.unsplash.com/photo-1604977042946-1eecc30f269e?w=200&h=200&fit=crop', // pickles
  tp3: 'https://images.unsplash.com/photo-1486297678162-eb2a19b0a32d?w=200&h=200&fit=crop', // mozzarella
  tp4: 'https://images.unsplash.com/photo-1564894809611-1742fc40ed80?w=200&h=200&fit=crop', // edamame
  tp5: 'https://images.unsplash.com/photo-1504545102780-26774c1bb073?w=200&h=200&fit=crop', // mushrooms natural
  // Aderezos
  a1: 'https://images.unsplash.com/photo-1472476443507-c7a5948772fc?w=200&h=200&fit=crop', // house dressing
  a2: 'https://images.unsplash.com/photo-1541014741259-de529411b96a?w=200&h=200&fit=crop', // balsamic
  a3: 'https://images.unsplash.com/photo-1472476443507-c7a5948772fc?w=200&h=200&fit=crop', // ranch
  a4: 'https://images.unsplash.com/photo-1528750717929-32abb73d3bd9?w=200&h=200&fit=crop', // honey mustard
  a5: 'https://images.unsplash.com/photo-1474979266404-7eaacbcd87c5?w=200&h=200&fit=crop', // olive oil
  // Semillas
  s1: 'https://images.unsplash.com/photo-1508061253366-f7da158b6d46?w=200&h=200&fit=crop', // sesame
  s2: 'https://images.unsplash.com/photo-1514994667787-b48ca37155f0?w=200&h=200&fit=crop', // mixed seeds
}

export const BOWL_OPTIONS: Record<string, ProductOption[]> = {
  bases: [
    { id: 'b1', name: 'Fideos de arroz', price: 1000 },
    { id: 'b2', name: 'Arroz blanco', price: 600 },
    { id: 'b3', name: 'Lechuga', price: 350 },
    { id: 'b4', name: 'Quinoa', price: 700 },
    { id: 'b5', name: 'Pasta tipo pluma de garbanzos', price: 700 },
    { id: 'b6', name: 'Mix de hojas verdes', price: 700 },
  ],
  proteinas: [
    { id: 'p1', name: 'Salmón', price: 2000 },
    { id: 'p2', name: 'Atún', price: 1800 },
    { id: 'p3', name: 'Camarón', price: 2000 },
    { id: 'p4', name: 'Pollo', price: 1200 },
  ],
  toppings: [
    { id: 't1', name: 'Hongos (tarro)', price: 400 },
    { id: 't2', name: 'Huevo duro', price: 400 },
    { id: 't3', name: 'Cebolla crujiente', price: 400 },
    { id: 't4', name: 'Maíz dulce', price: 400 },
    { id: 't5', name: 'Cebolla morada', price: 400 },
    { id: 't6', name: 'Tomate cherry', price: 400 },
    { id: 't7', name: 'Frijoles negros', price: 400 },
    { id: 't8', name: 'Chile dulce', price: 400 },
    { id: 't9', name: 'Garbanzo', price: 400 },
    { id: 't10', name: 'Zanahoria', price: 400 },
    { id: 't11', name: 'Plátano maduro', price: 400 },
    { id: 't12', name: 'Cebollín', price: 400 },
    { id: 't13', name: 'Pepino', price: 400 },
    { id: 't14', name: 'Palmito', price: 400 },
    { id: 't15', name: 'Mango', price: 400 },
    { id: 't16', name: 'Fresa', price: 400 },
    { id: 't17', name: 'Piña', price: 400 },
    { id: 't18', name: 'Crutones', price: 400 },
  ],
  toppingsPremium: [
    { id: 'tp1', name: 'Aguacate', price: 700 },
    { id: 'tp2', name: 'Pepinillos', price: 700 },
    { id: 'tp3', name: 'Queso mozzarella', price: 700 },
    { id: 'tp4', name: 'Edamames', price: 700 },
    { id: 'tp5', name: 'Hongos naturales', price: 700 },
  ],
  aderezos: [
    { id: 'a1', name: 'Aderezo de la casa', price: 200 },
    { id: 'a2', name: 'Vinagreta balsámica', price: 200 },
    { id: 'a3', name: 'Ranch', price: 200 },
    { id: 'a4', name: 'Mostaza miel', price: 200 },
    { id: 'a5', name: 'Aceite de oliva y limón', price: 200 },
  ],
  semillas: [
    { id: 's1', name: 'Ajonjolí', price: 200 },
    { id: 's2', name: 'Semillas varias', price: 200 },
  ],
}

export const MENU_PRODUCTS: Product[] = [
  {
    id: 'prod_sandwich',
    name: 'Sándwich',
    description:
      'Armá tu sándwich en la barra, incluye 4 toppings, pan ciabatta, aderezo a elegir y chips',
    price: 4000,
    category: 'Sándwich',
    customizable: true,
    type: 'sandwich',
    image:
      'https://images.unsplash.com/photo-1528735602780-2552fd46c7af?w=600&h=400&fit=crop',
  },
  {
    id: 'prod_wrap',
    name: 'Wrap',
    description:
      'Armá tu wrap en la barra, incluye 4 toppings, tortilla de trigo, aderezo a elegir y chips',
    price: 4000,
    category: 'Wrap',
    customizable: true,
    type: 'wrap',
    image:
      'https://images.unsplash.com/photo-1626700051175-6818013e1d4f?w=600&h=400&fit=crop',
  },
  {
    id: 'prod_crema_ayote',
    name: 'Crema de Ayote',
    description: 'Acompañadas de crutones y queso mozzarella',
    price: 2000,
    category: 'Cremas',
    type: 'crema',
    image:
      'https://images.unsplash.com/photo-1476718406336-bb5a9690ee2a?w=600&h=400&fit=crop',
  },
  {
    id: 'prod_crema_tomate',
    name: 'Crema de Tomate',
    description: 'Acompañadas de crutones y queso mozzarella',
    price: 2000,
    category: 'Cremas',
    type: 'crema',
    image:
      'https://images.unsplash.com/photo-1547592166-23ac45744acd?w=600&h=400&fit=crop',
  },
  {
    id: 'prod_snack_bowl',
    name: 'Snack Bowl',
    description: 'Smoothie bowl del día con frutas y toppings a elegir',
    price: 2900,
    category: 'Snack Bowl',
    customizable: true,
    type: 'snack_bowl',
    image:
      'https://images.unsplash.com/photo-1590301157890-4810ed352733?w=600&h=400&fit=crop',
  },
  {
    id: 'prod_ninos_pollo',
    name: 'Dedos de pollo',
    description:
      'Filetes de pollo ligeramente empanizados, servidos con chips y aderezo a elegir',
    price: 3500,
    category: 'Niños',
    type: 'ninos',
    image:
      'https://images.unsplash.com/photo-1562967914-608f82629710?w=600&h=400&fit=crop',
  },
  // Bebidas — Naturales en Agua
  {
    id: 'beb_nat_agua_fresa',
    name: 'Natural en agua - Fresa',
    price: 1200,
    category: 'Bebidas',
    subcategory: 'Naturales en Agua',
    type: 'bebida',
    image:
      'https://images.unsplash.com/photo-1497534446932-c925b458314e?w=600&h=400&fit=crop',
  },
  {
    id: 'beb_nat_agua_mora',
    name: 'Natural en agua - Mora',
    price: 1200,
    category: 'Bebidas',
    subcategory: 'Naturales en Agua',
    type: 'bebida',
    image:
      'https://images.unsplash.com/photo-1553530666-ba11a7da3888?w=600&h=400&fit=crop',
  },
  {
    id: 'beb_nat_agua_pina',
    name: 'Natural en agua - Piña',
    price: 1200,
    category: 'Bebidas',
    subcategory: 'Naturales en Agua',
    type: 'bebida',
    image:
      'https://images.unsplash.com/photo-1544145945-f90425340c7e?w=600&h=400&fit=crop',
  },
  {
    id: 'beb_nat_agua_banano',
    name: 'Natural en agua - Banano',
    price: 1200,
    category: 'Bebidas',
    subcategory: 'Naturales en Agua',
    type: 'bebida',
    image:
      'https://images.unsplash.com/photo-1571771894821-ce9b6c11b08e?w=600&h=400&fit=crop',
  },
  // Bebidas — Naturales en Leche
  {
    id: 'beb_nat_leche_fresa',
    name: 'Natural en leche - Fresa',
    price: 1500,
    category: 'Bebidas',
    subcategory: 'Naturales en Leche',
    type: 'bebida',
    image:
      'https://images.unsplash.com/photo-1638176066666-ffb2f013c7dd?w=600&h=400&fit=crop',
  },
  {
    id: 'beb_nat_leche_mora',
    name: 'Natural en leche - Mora',
    price: 1500,
    category: 'Bebidas',
    subcategory: 'Naturales en Leche',
    type: 'bebida',
    image:
      'https://images.unsplash.com/photo-1553530666-ba11a7da3888?w=600&h=400&fit=crop',
  },
  {
    id: 'beb_nat_leche_pina',
    name: 'Natural en leche - Piña',
    price: 1500,
    category: 'Bebidas',
    subcategory: 'Naturales en Leche',
    type: 'bebida',
    image:
      'https://images.unsplash.com/photo-1544145945-f90425340c7e?w=600&h=400&fit=crop',
  },
  {
    id: 'beb_nat_leche_banano',
    name: 'Natural en leche - Banano',
    price: 1500,
    category: 'Bebidas',
    subcategory: 'Naturales en Leche',
    type: 'bebida',
    image:
      'https://images.unsplash.com/photo-1571771894821-ce9b6c11b08e?w=600&h=400&fit=crop',
  },
  // Bebidas — Smoothies
  {
    id: 'beb_smo_tropical',
    name: 'Smoothie tropical',
    description: 'piña y fresa',
    price: 1200,
    category: 'Bebidas',
    subcategory: 'Smoothies',
    type: 'bebida',
    image:
      'https://images.unsplash.com/photo-1505252585461-04db1eb84625?w=600&h=400&fit=crop',
  },
  {
    id: 'beb_smo_berry',
    name: 'Smoothie Berry Mix',
    description: 'fresa, mora y arándanos',
    price: 1500,
    category: 'Bebidas',
    subcategory: 'Smoothies',
    type: 'bebida',
    image:
      'https://images.unsplash.com/photo-1553530666-ba11a7da3888?w=600&h=400&fit=crop',
  },
  {
    id: 'beb_smo_alma',
    name: 'Smoothie Nombre de tu negocio',
    description: 'espinaca, pepino, apio, piña y miel de abeja',
    price: 1200,
    category: 'Bebidas',
    subcategory: 'Smoothies',
    type: 'bebida',
    image:
      'https://images.unsplash.com/photo-1610970881699-44a5587cabec?w=600&h=400&fit=crop',
  },
  // Bebidas — Gaseosas
  {
    id: 'beb_gas_coca',
    name: 'Coca Cola lata 237ml',
    price: 550,
    category: 'Bebidas',
    subcategory: 'Gaseosas',
    type: 'bebida',
    image:
      'https://images.unsplash.com/photo-1629203851122-3726ecdf080e?w=600&h=400&fit=crop',
  },
  {
    id: 'beb_gas_fanta',
    name: 'Fanta naranja lata 237ml',
    price: 550,
    category: 'Bebidas',
    subcategory: 'Gaseosas',
    type: 'bebida',
    image:
      'https://images.unsplash.com/photo-1624517452488-04869289c4ca?w=600&h=400&fit=crop',
  },
  {
    id: 'beb_gas_sprite',
    name: 'Sprite lata 237ml',
    price: 550,
    category: 'Bebidas',
    subcategory: 'Gaseosas',
    type: 'bebida',
    image:
      'https://images.unsplash.com/photo-1625772299848-391b6a87d7b3?w=600&h=400&fit=crop',
  },
  // Bebidas — Otras
  {
    id: 'beb_otr_agua_gas',
    name: 'Agua con gas Sparkling 503ml',
    price: 1000,
    category: 'Bebidas',
    subcategory: 'Otras',
    type: 'bebida',
    image:
      'https://images.unsplash.com/photo-1559839914-17aae19cec71?w=600&h=400&fit=crop',
  },
  {
    id: 'beb_otr_tropical',
    name: 'Tropical (variado) 250ml',
    price: 600,
    category: 'Bebidas',
    subcategory: 'Otras',
    type: 'bebida',
    image:
      'https://images.unsplash.com/photo-1600271886742-f049cd451bba?w=600&h=400&fit=crop',
  },
  {
    id: 'beb_otr_agua',
    name: 'Botella de agua 500ml',
    price: 800,
    category: 'Bebidas',
    subcategory: 'Otras',
    type: 'bebida',
    image:
      'https://images.unsplash.com/photo-1548839140-29a749e1cf4d?w=600&h=400&fit=crop',
  },
  // Bebidas — Calientes
  {
    id: 'beb_cal_aguadulce',
    name: 'Aguadulce en agua o leche',
    price: 900,
    category: 'Bebidas',
    subcategory: 'Calientes',
    type: 'bebida',
    image:
      'https://images.unsplash.com/photo-1544787219-7f47ccb76574?w=600&h=400&fit=crop',
  },
  {
    id: 'beb_cal_chocolate',
    name: 'Chocolate caliente en agua o leche',
    price: 900,
    category: 'Bebidas',
    subcategory: 'Calientes',
    type: 'bebida',
    image:
      'https://images.unsplash.com/photo-1542990253-0d0f5be5f0ed?w=600&h=400&fit=crop',
  },
]
